import styled from 'styled-components';

import { Button as Btn, TextField as Input } from '@mui/material';

export const Container = styled.div``;

export const Content = styled.div``;

export const Button = styled(Btn)`
  margin: 20px 0 15px !important;
  background-color: #00a65a !important;
  color: #fff !important;
`;
